import { render, staticRenderFns } from "./RoomingListPrint.vue?vue&type=template&id=90db8556"
import script from "./RoomingListPrint.vue?vue&type=script&lang=js"
export * from "./RoomingListPrint.vue?vue&type=script&lang=js"
import style0 from "./RoomingListPrint.vue?vue&type=style&index=0&id=90db8556&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports